export default {
  title: {
    changeEmailRequest: '更改邮箱申请',
    bindEmailRequest: '绑定邮箱申请'
  },
  label: {
    currentEmail: '当前邮箱',
    newEmail: '新邮箱',
    password: '密码'
  },
  message: {
    youAreUsingTheEmail: '你正在使用此邮箱地址',
    requestSuccess: '您已经成功申请了修改邮箱，请到新邮箱检查邮件以便继续。'
  }
}
